const routes = {
  authentication: '/login',
  dashboard: '/',
  files_list: '/files_list',
  file_details: '/file-details/:id',
  help: '/help',
  recorder: '/recorder',
};

export const PATH_DEFAULT = '';

export const PATH_FILE_DETAILS = '/file-details';

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js